export const environment = {
   production: true,
};

export const IPBXID = undefined;
export const SOCKET_SERVER = "https://wss-v2.kerberusipbx.com";
export const API_ADDRESS = undefined;
